import { InjectionToken } from '@angular/core';
import { HttpCacheStoreLike } from './cache-store.model';

export const HTTP_CACHE_STORE = new InjectionToken<HttpCacheStoreLike>('HTTP_CACHE.STORE');
export const HTTP_CACHE_TTL = new InjectionToken<number>('HTTP_CACHE.TTL');
